import { atom } from "jotai";

export const zslCreatorBaseUrlAtom = atom<string>("");
zslCreatorBaseUrlAtom.debugLabel = "zslCreatorBaseUrlAtom";
